const selectFeatureSearchContext = (state) => state.experimentSearchModule.featureSearchV4.context;
const selectUserAffinity = (state) => state.currentUserDetails.userAffinity;
export {
  selectFeatureSearchContext,
  selectUserAffinity
};
//# sourceMappingURL=selectors.js.map
